<div class="container">
    <div class="row mt-3 mb-3">
        <div class="col">
            <div class="card">
                <form [formGroup]="printerFormGroup" (ngSubmit)="onPrinterFormsSubmit()">
                    <div class="card-header">
                        Printer
                    </div>
                    <div class="card-body">
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">printer identifier *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['identifier'] }"
                                    formControlName="identifier" />
                                <div *ngIf="validationErrorsArray['identifier']" class="invalid-feedback">
                                    {{validationErrorsArray['identifier']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">printer name *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <input type="input" class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['name'] }"
                                    formControlName="name" />
                                <div *ngIf="validationErrorsArray['name']" class="invalid-feedback">
                                    {{validationErrorsArray['name']}}
                                </div>
                            </dd>
                        </dl>

                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">status *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['status'] }"
                                    formControlName="status">
                                    <option *ngFor="let status of printerStatusArray" [value]=status.value>
                                        {{status.label}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['status']" class="invalid-feedback">
                                    {{validationErrorsArray['status']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                            <dt class="col-sm-3 text-right align-middle">
                                <label class="control-label col-form-label-sm">printer type *</label>
                            </dt>
                            <dd class="col-sm-3">
                                <select class="form-control form-control-sm"
                                    [ngClass]="{ 'is-invalid': validationErrorsArray['printerType'] }"
                                    formControlName=printerType>
                                    <option *ngFor="let printerType of printerTypes" [value]="printerType.id">
                                        {{printerType.name}}</option>
                                </select>
                                <div *ngIf="validationErrorsArray['printerType']" class="invalid-feedback">
                                    {{validationErrorsArray['printerType']}}
                                </div>
                            </dd>
                        </dl>
                        <dl class="row">
                          <dt class="col-sm-3 text-right align-middle">
                              <label class="control-label col-form-label-sm">notes</label>
                          </dt>
                          <dd class="col-sm-3">
                              <textarea class="form-control form-control-sm" formControlName="notes" rows="10"></textarea>
                          </dd>
                        </dl>
                    </div>
                    <div class="card-footer">
                        <a class="btn btn-default btn-sm" href="/hardware/printers">
                            <i class="fa fa-times"></i> <br /> Cancel
                        </a>
                        <button class="btn btn-primary btn-sm float-right" type="submit">
                            <i class="fa fa-save"></i> <br />
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
